module.exports = __webpack_public_path__ + "static/media/screenshot(25).93b31d01.jpg";